import { render, staticRenderFns } from "./DxpDescriptionImageCard.vue?vue&type=template&id=7d78a4d3&scoped=true"
import script from "./DxpDescriptionImageCard.vue?vue&type=script&lang=js"
export * from "./DxpDescriptionImageCard.vue?vue&type=script&lang=js"
import style0 from "./DxpDescriptionImageCard.vue?vue&type=style&index=0&id=7d78a4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d78a4d3",
  null
  
)

export default component.exports